

  <!-- <ng-container *ngIf="list">
  <a class="dropdown-item cursor-pointer p-1 " data-toggle="modal" [attr.data-target]="'#projectTemplateModal'+project.projectId">
    <p class="mb-0 align-middle cursor-pointer pl-2 lh-25">Generate template
        <span class="material-icons f-24 lh-25 align-middle pl-1 pr-1 float-right cursor-pointer" matTooltip="Generate template" matTooltipPosition="above" matTooltipShowDelay="500">
            post_add
          </span>
    </p>
  </a>
  </ng-container>

  <ng-container *ngIf="!list">
    <span matTooltip="Create Template" matTooltipPosition="above" matTooltipShowDelay="500" data-toggle="modal" [attr.data-target]="'#projectTemplateModal'+project.projectId" 
    class="material-icons cursor-pointer opacity-reverse f-24 pr-1 pl-1 zoom">
      post_add
      </span>
  
  </ng-container> -->

<!--Create project template modal
 <div class="modal-dialog" role="document">-->
  
    <app-loadconfirm  *ngIf="loader" [text]="'projecttemplatecreate.loader' | trans " [icon]="'pending'"></app-loadconfirm>
  
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ 'projecttemplatecreate.header' | trans }}</h5>
          <button (click)="closeModal()" type="button" class="close" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
         <div class="form-group">
          <label class="h6 modal-title" for="exampleFormControlInput1">{{ 'projecttemplatecreate.templatetitle' | trans }}</label>
          <input style="font-size: 13px;" class="form-control" id="exampleFormControlInput1" placeholder="{{ 'projecttemplatecreate.templatetitleplace' | trans }}" [(ngModel)]="ptemplate.title" required>
        </div>
         <div class="form-group">
          <label class="h6 modal-title" for="exampleFormControlTextarea1">{{ 'projecttemplatecreate.templatedescription' | trans }}</label>
          <textarea style="font-size: 13px;" class="form-control" id="exampleFormControlTextarea1" placeholder="{{ 'projecttemplatecreate.templatedescriptionplace' | trans }}" rows="3" [(ngModel)]="ptemplate.templatedescription" required></textarea>
        </div>
        <div class="form-group">
          <label class="h6 modal-title" for="workloadfte">Workload FTE</label>
          <input style="font-size: 13px;" type="number" min="0" step="0.1" class="form-control" id="workloadfte" placeholder="1.0" [(ngModel)]="ptemplate.workload_fte">
        </div>
        <div *ngIf="errorMessage!=null && updateMessage==null" class="alert alert-danger ml-0 mr-0">
          <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
      </div>
        </div>
        <div class="modal-footer">
        
            <div class="col">
              <button (click)="closeModal()" class="btn-close float-left"><h6 class="btn-save-text">{{ 'projecttemplatecreate.close' | trans }}</h6></button>
            </div>
            <div class="col">
              <button (click)="createTemplate()" class="btn-save float-right"><h6 class="btn-save-text">{{ 'projecttemplatecreate.createtemplate' | trans }}</h6></button>
          </div>
        </div>
      </div>
    <!-- </div> -->
 